<template>
  <div class="width98 margin-auto f14 margin-top10">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <!-- 检索 -->

        <div class="Retrieveform pad-top20 pad-bot10 lineheight40">
          <div class="flex-betweennowrap width96 margin-auto">
            <p class="Patent-abstract pad-left10 dimensional">基本信息</p>
            <div>
              <span class="cursorpointer attention" @click="addpatendfllow()">
                专利关注
              </span>
              <span
                class="cursorpointer attention margin-left10"
                @click="Testmatchingdegree()"
              >
                匹配度测试
              </span>
            </div>
          </div>
          <div class="width96 margin-auto pad-top20 pad-bot20">
            <table class="width100 text-ellipsis">
              <tr>
                <td class="tdtit">申请号</td>
                <td class="tdcont">{{ appNumber }}</td>
                <td class="tdtit">申请公布号</td>
                <td class="tdcont">{{ pubNumber }}</td>
              </tr>
              <tr>
                <td class="tdtit">申请日</td>
                <td class="tdcont">{{ appDate }}</td>
                <td class="tdtit">申请公布日期</td>
                <td class="tdcont">{{ pubDate }}</td>
              </tr>
              <tr>
                <td class="tdtit">申请（专用权）人</td>
                <td class="tdcont">{{ applicantName }}</td>
                <td class="tdtit">发明（设计）人</td>
                <td class="tdcont">{{ inventroName }}</td>
              </tr>
              <tr>
                <td class="tdtit">国省代码</td>
                <td class="tdcont">{{ proCode }}</td>
                <td class="tdtit">当前专利权人</td>
                <td class="tdcont">{{ patentee }}</td>
              </tr>
              <tr>
                <td class="tdtit">主分类号</td>
                <td class="tdcont">{{ mainIpc }}</td>
                <td class="tdtit">代理人</td>
                <td class="tdcont">{{ agentName }}</td>
              </tr>
            </table>
            <table class="width100 text-ellipsis">
              <tr>
                <td class="tdtit" style="border-top: none">分类号</td>
                <td
                  class="tdconts"
                  style="
                    border-top: none;
                    word-break: break-word;
                    white-space: pre-line;
                  "
                >
                  {{ ipc }}
                </td>
              </tr>
              <tr v-if="dbName != '外观专利'">
                <td class="tdtit">分类信息</td>
                <td
                  v-for="(item, index) in ipc_info"
                  :key="index"
                  class="flex pad-left10 pad-right10"
                  style="border-top: none; border-left: none"
                >
                  <span style="color: #52c5cb" class="f14 pad-right20">{{
                    item.class
                  }}</span>
                  <span
                    style="word-break: break-word; white-space: pre-line"
                    class="lineheight30 pad-top5"
                  >
                    {{ item.detail }}
                  </span>
                </td>
              </tr>
              <tr v-if="dbName == '外观专利'">
                <td class="tdtit">分类信息</td>
                <td
                  v-for="(item, index) in locarno"
                  :key="index"
                  class="flex pad-left10 pad-right10"
                  style="border-top: none; border-left: none"
                >
                  <span style="color: #52c5cb" class="f14 pad-right20">{{
                    item.code
                  }}</span>
                  <span style="word-break: break-word; white-space: pre-line">
                    {{ item.full_cate }} {{ item.product_cn }} (
                    {{ item.product_en }} )
                  </span>
                </td>
              </tr>
              <tr>
                <td class="tdtit">代理机构</td>
                <td class="tdconts" style="border-top: none">
                  {{ agencyName }}
                </td>
              </tr>
              <tr>
                <td class="tdtit">地址</td>
                <td class="tdconts">{{ address }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="Retrieveform pad-top20 pad-bot10 lineheight30 f14 margin-top10"
        >
          <div class="width96 margin-auto">
            <p class="Patent-abstract pad-left10 dimensional">专利摘要</p>
            <p class="f14 pad-top20 pad-bot20">
              {{ abs }}
            </p>
          </div>
        </div>
        <div class="Retrieveform pad-top20 pad-bot20 lineheight30 margin-top10">
          <div class="width96 margin-auto">
            <p class="Patent-abstract pad-left10 dimensional">法律状态</p>
            <p class="f14 flexleft pad-top20">
              <span class="tdtit" style="width: 32%">法律状态公告日 </span
              ><span class="tdtit" style="width: 32%">法律状态 </span
              ><span class="tdtit" style="width: 32%">法律状态信息</span>
            </p>
            <p class="f14 flexlefts pad-bot20">
              <span class="tdcontss" style="width: 32%">{{ pubDate }} </span
              ><span class="tdcontss" style="width: 32%">{{ lprs }} </span
              ><span class="tdcontss" style="width: 32%">{{ legalList }}</span>
            </p>
          </div>
        </div>
        <!-- <div
          class="Retrieveform pad-top20 pad-bot20 lineheight30 margin-top10"
          v-if="tests"
        >
          <div class="width96 margin-auto">
            <p class="Patent-abstract pad-left10 dimensional">匹配度</p>
            <div class="pad-top20">
              <p>
                经分析，该专利所描述的技术和您的企业匹配分值为：<span
                  class="f18 bluecolor"
                  >{{ datavalue }}T</span
                >
              </p>
              <p>
                说明：该结果基于人工智能语义分析获得,最高总分值为100T,分值越高代表技术匹配度越高。
              </p>
            </div>
          </div>
        </div> -->
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibletests"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
    >
      <p class="textalign-left f16">匹配度</p>
      <div class="textalign-left margin-top10">
        <div class="width100 margin-auto">
          <div class="pad-top10">
            <p>
              经分析，该专利所描述的技术和您的企业匹配分值为：<span
                class="f18 bluecolor"
                >{{ datavalue }}T</span
              >
            </p>
            <p class="pad-top10">
              说明：该结果基于人工智能语义分析获得,最高总分值为100T,分值越高代表技术匹配度越高。
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisibletests = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { patenttrusteeshipdetail } from "@/api/patent/patent.api";
import { followpatentfllow } from "@/api/Center/Center.api";
import { patenttrusteeshipmatch } from "@/api/patent/patent.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      title: "",
      appNumber: "",
      appDate: "",
      pubDate: "",
      pubNumber: "",
      abs: "",
      agencyName: "",
      inventroName: "",
      name: "",
      Esid: "",
      mainIpc: "",
      ipc: "",
      patentKey: "",
      dbName: "",
      applicantName: "",
      agentName: "",
      legalList: "",
      lprs: "",
      patentee: "",
      cont: "",
      address: "",
      proCode: "",
      ipc_info: [],
      locarno: [],
      dialogVisibletests: false,
      datavalue: "",
    };
  },
  methods: {
    // 加入瞭望台
    addpatendfllow() {
      followpatentfllow({ patent_id: this.cont.id }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入",
            type: "success",
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 测试匹配度
    Testmatchingdegree() {
      this.dialogVisibletests = true;
      patenttrusteeshipmatch({ id: this.patentKey }).then((res) => {
        if (res.data.code == 200) {
          this.datavalue = Number(res.data.data * 100).toFixed(2);
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    // 获取专利详情
    this.patentKey = window.sessionStorage.getItem("patentmanage");
    patenttrusteeshipdetail({ id: this.patentKey }).then((res) => {
      if (res.data.code == 200) {
        this.cont = res.data.data;
        this.title = this.cont.title;
        this.appNumber = this.cont.appNumber;
        this.dbName = this.cont.dbName;
        if (this.dbName == "SYXX") {
          this.dbName = "实用新型";
          this.ipc_info = this.cont.ipc_info[0];
        }
        if (this.dbName == "FMZL") {
          this.dbName = "发明专利";
          this.ipc_info = this.cont.ipc_info[0];
        }
        if (this.dbName == "WGZL") {
          this.dbName = "外观专利";
          this.locarno = this.cont.locarno;
        }
        this.appDate = this.cont.appDate;
        this.pubDate = this.cont.pubDate;
        this.agencyName = this.cont.agencyName;
        this.pubNumber = this.cont.pubNumber;
        this.abs = this.cont.abs;
        this.inventroName = this.cont.inventroName;
        this.applicantName = this.cont.applicantName;
        this.agentName = this.cont.agentName;
        this.mainIpc = this.cont.mainIpc;
        this.patentee = this.cont.patentee;
        this.legalList = this.cont.legalList;
        this.lprs = this.cont.lprs;
        this.address = this.cont.address;
        this.proCode = this.cont.proCode;
        this.ipc = this.cont.ipc;
        // this.ipc_info = this.cont.ipc_info[0];
        // this.locarno = this.cont.locarno;
      } else {
        this.drawer = false;
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.Retrieveform {
  background: #fff;
  border-radius: 3px;
}
.pagination {
  border-bottom: 1px solid #cacaca;
}
.Patent-abstract {
  border-left: 4px solid #52c5cb;
  height: 20px;
  line-height: 20px;
}
.icon {
  font-size: 12px;
}
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  line-height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.tdcontss {
  width: 15%;
  padding-left: 10px;
  font-size: 14px;
  color: #353a44;
  border-top: none;
}
.tdconts {
  width: 85%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>